<template>
  <div class="d-flex flex-gap-sm bg-lighten-4" style="height: 39px !important">
    <b-button class="default-button-style" @click="$refs.refInputEl.click()">
      <input
        ref="refInputEl"
        type="file"
        class="d-none"
        accept=".html"
        @change="updateFormDataResumeTemplate"
      />
      Upload Resume Template
    </b-button>

    <b-button
      class="btn-warning border-0"
      :disabled="uploadedResumeTemplate == null"
      @click="postResumeTemplate"
    >
      Submit
    </b-button>
  </div>
</template>

<script>
import { cloneDeep, debounce, difference, orderBy } from "lodash"

export default {
  props: {
    //
  },

  data() {
    return {
      resumeTemplate: {},
      isLoading: false,
      formData: new FormData(),

      uploadedResumeTemplate: null,
    }
  },

  watch: {
    //
  },

  created() {
    this.initComponent()
  },

  methods: {
    initComponent() {
      //
    },

    updateFormDataResumeTemplate(input) {
      const file = input.target.files[0]
      // this.previewImage(file, 'refFrontImageImg')
      this.uploadedResumeTemplate = file
      this.formData.append("resume_html_file", file)
    },

    postResumeTemplate() {
      this.isLoading = true
      this.formData.append(
        "form_data",
        JSON.stringify({
          title: "template",
        })
      )

      const headers = {
        "Content-Type": "multipart/form-data",
      }

      this.$http
        .post(`/api/resume-templates`, this.formData, {
          headers,
        })
        .then((response) => {
          const { success, message, output } = response.data
          if (success) {
            // this.businessCard = output
            this.$toastSuccess("Operation Success", message)

            // const route = this.$router.resolve({ name: 'business-cards-payment-success', params: { id: this.businessCard.id } }).href
            // this.stripeReturnUrl = new URL(route, window.location.origin).href

            // this.formType = 'edit'
            // this.cardId = this.businessCard.id

            this.isLoading = false

            // this.$refs.refBusinessCardWizard.nextTab()
            // this.$emit('refresh-record')
            this.resumeTemplate = output
          }
        })
        .catch((error) => {
          this.$handleResponseError(error)
          this.isLoading = false
        })

      this.uploadedResume = this.templates[0] // placeholder
    },
  },
}
</script>

<style lang="scss" scoped></style>
